module.exports = __webpack_public_path__ + "static/img/icon-hotel-type0.d9521e56.png";